import FileManagerContainer from "../../../Components/Application/FileManager/FileManager"

const FileManager = () => {
  return (
    <div className='page-body'>
      <FileManagerContainer />
    </div>
  )
}

export default FileManager